import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import Wrapper from './wrapper';
import Label from './label';

export const query = graphql`
  fragment StrapiFormSelect on STRAPI_ComponentFormsSelect {
    id
    name
    label
    required
    values {
      value
      label
    }
  }
`;

const Select = ({
  className,
  name,
  label = null,
  required = false,
  values = [],
  onChange,
  value,
}) => (
  <Wrapper>
    {label && <Label required={required}>{label}</Label>}
    <select
      className={className}
      name={name}
      required={required}
      onChange={onChange}
      value={value}
    >
      {!required && <option>...</option>}
      {values.map(({ value: vlu, label: lbl }) => (
        <option key={vlu} value={vlu}>{lbl || vlu}</option>
      ))}
    </select>
  </Wrapper>
);

export default styled(Select)``;
